import React,{useState} from 'react'
import { Box,TextField, Typography,Button } from '@mui/material'
import QRCode from 'qrcode'
import {useHistory} from 'react-router-dom'
import EnlistDocument from '../../Components/EnlistDocument/EnlistDocument'
export default function VerifyRegistration() {
    const [qr,setQr]=useState()
    const history=useHistory()
    const createQR=()=>{
        QRCode.toDataURL(`https://astha-bd.web.app/id/A4FJVY7`).then((url)=>{
            setQr(url)
        })
    }
  return (
    <Box sx={{width:"100vw",minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",margin:{md:"7vh"}}}>
        <EnlistDocument/>
        <Box>
            <img id="qrCanvas" src={qr}/>
          
        </Box>
        
    </Box>
  )
}

